export function AIChipIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 10.3333L3.33333 10.3334M2.00012 7.9997L3.33333 7.99993M2.00024 5.66667L3.33333 5.6667M14 5.6667L12.6667 5.66667M13.9999 8.0003L12.6667 8.00007M13.9998 10.3334L12.6667 10.3333M5.6667 2L5.66667 3.33333M8.0003 2.00012L8.00007 3.33333M10.3334 2.00024L10.3333 3.33333M10.3333 14L10.3334 12.6667M7.9997 13.9999L7.99993 12.6667M5.66667 13.9998L5.6667 12.6667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 12.6667H6C4.52724 12.6667 3.33333 11.4728 3.33333 10V6C3.33333 4.52724 4.52724 3.33333 6 3.33333H10C11.4728 3.33333 12.6667 4.52724 12.6667 6V10C12.6667 11.4728 11.4728 12.6667 10 12.6667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.8214 8.92H8.18427M8.38667 9.53333L7.39333 6.46667H6.62L5.62667 9.53333M10.0733 9.53333V6.46667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
